import { useNavigate } from "react-router-dom";

import { Button, Form, Input, message } from "antd";
import { FC, useEffect, useState } from "react";

import SuccessModal from "@/components/common/SuccessModal";
import { IMAGES, ROUTES_URL } from "@/constant";
import styles from "@/pages/ResetPassword/ResetPassword.module.css";
import { resetPasswordNew } from "@/services/Auth/AuthApi";
import { useAuthStore } from "@/stores/authStore";
import { validatePassword } from "@/utils";

const ResetPassword: FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { email, isTCAccepted, hashKey, updateState, logout } = useAuthStore();
  const [confirm, setConfirm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const onFinish = async (values: { new_password: string }): Promise<void> => {
    try {
      if (!email || !hashKey) return;
      await resetPasswordNew({ token: hashKey, email: email, new_password: values.new_password });
      message.success("Password reset successful");
      updateState({ hashKey: null, email: null, isAuthenticated: false, token: null });
      setConfirm(true);
      // if (isTCAccepted) {
      // } else {
      //   updateState({ hashKey: null, email: null, isAuthenticated: true, isTCAccepted: false });
      //   navigate(ROUTES_URL.TERMS);
      // }
    } catch (error: unknown) {
      // if (axios.isAxiosError<{ message: string }>(error)) {
      //   message.error(error?.response?.data?.message || "Reset failed");
      // }
    }
  };

  useEffect(() => {
    if (!email || !hashKey) {
      navigate(ROUTES_URL.LOGIN);
    }

    const handleBeforeUnload = () => {
      logout();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      logout();
    };
  }, []);

  return (
    <div className={styles.gradientBg}>
      {confirm ? (
        <SuccessModal
          title="Password has been changed successfully"
          open={confirm}
          isBackToLogin={true}
        />
      ) : (
        <div className={styles.formContainer}>
          <h2 className={styles.loginHeading}>Reset Password</h2>
          <p className={styles.loginSubTitle}>Choose your new password and confirm to proceed</p>

          <Form form={form} name="login" layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="new_password"
              label="Enter New Password"
              required={false}
              className={styles.password}
              rules={[
                { required: true, message: "Password is required" },
                {
                  validator: (_, value) => {
                    if (!value || validatePassword(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
                      ),
                    );
                  },
                },
              ]}
            >
              <Input.Password
                placeholder="Enter new password"
                prefix={<img src={IMAGES.PASSWORD_ICON} className={styles.passwordIcon} />}
              />
            </Form.Item>
            <Form.Item
              name="confirm_password"
              label="Confirm new password"
              className={styles.password}
              required={false}
              dependencies={["new_password"]}
              rules={[
                { required: true, message: "Confirm Password is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Confirm your password"
                prefix={<img src={IMAGES.PASSWORD_ICON} className={styles.passwordIcon} />}
              />
            </Form.Item>

            <Form.Item className={styles.login}>
              <Button block htmlType="submit" loading={loading} className={styles.submitButton}>
                Confirm
              </Button>
            </Form.Item>
          </Form>
          <div className={styles.footer} onClick={() => navigate(ROUTES_URL.LOGIN)}>
            <img src={IMAGES.LOGIN_RIGHT_ARROW} alt="back to login" /> Back to Login
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
